import { Address } from '~domains/partner-application/entities/application';

import { InfoField } from '~shared/ui/info-field';

export const AddressReviewItems = ({ address }: { address: Address }) => {
  return (
    <>
      <InfoField title="Province" value={address.province} />
      <InfoField title="City/Municipality" value={address.cityOrMunicipality} />
      <InfoField title="ZIP Code" value={address.postalCode} />
      <InfoField title="Barangay" value={address.barangay} />
      <InfoField
        title="House number, Street name"
        value={address.streetAndHouse}
      />
      <InfoField
        title="Unit/Apartment (if any)"
        value={address.unitAndFloor}
        hideIfEmpty
      />
    </>
  );
};
